import {GetterTree} from 'vuex'
import {RootState} from '@/store'
import {EmployerDocumentState} from '@/store/modules/documents';

export const getters: GetterTree<EmployerDocumentState, RootState> = {

    documentTypes(state): any[] {
        return state.documentTypes
    }
}